import { createIcon } from '@/utils/factoryUtil'

export const SVGCommonCaret = createIcon('SVGCommonCaret', (props) => (
  <svg viewBox='0 0 100 100' {...props}>
    <path d='M43.7,77.76c3.94,3.19,9.72,2.97,13.37-.69l40-40c2.87-2.87,3.72-7.16,2.16-10.91s-5.19-6.16-9.22-6.16H10.02c-4.03,0-7.69,2.44-9.25,6.19s-.69,8.03,2.19,10.87l40,40,.75.69h0Z' />
  </svg>
))
